import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'

interface FailedWithdrawalProps {
  amountWithCurrency: string
  merchantId: string
}

const FailedWithdrawal = ({ amountWithCurrency, merchantId }: FailedWithdrawalProps) => {
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-returned"
          testId="amount-returned"
          title={i18next.t('transactions.sideBar.amountReturned')}
          body={amountWithCurrency}
        />
      )}

      {merchantId && (
        <DataListItem
          id="merchant-id"
          testId="merchant-id"
          title={i18next.t('transactions.sideBar.merchantId')}
          body={merchantId}
        />
      )}
    </>
  )
}

export default FailedWithdrawal
